export default __webpack_public_path__ + "static/media/QuienesSomos.3a9086a7.png";